import React from "react";
import { Link } from "gatsby";
import { useState } from "react";
import SearchBox from "../components/search-box";

function FooterContentPane({ children, title, className }) {
  return (
    <div className={`w-full md:max-w-lg ${className}`}>
      <p className="text-primary uppercase font-sans-title text-center text-4xl">
        {title}
      </p>
      {children}
    </div>
  );
}

function PopTopicText({ children }) {
  /**
  TODO: Replace this search hack with real categories
  */
  return (
    <Link
      to={`/destinations/?q=${encodeURI(children)}`}
      className="text-xl text-black uppercase p-2 px-4 flex-grow"
    >
      {children}
    </Link>
  );
}

export default function FooterContent({ children, className }) {
  const [query, setQuery] = useState("");

  // TODO: Re-enable the Popular Topics.  Remove "hidden" & "xxx-"
  return (
    <div
      className={`grid grid-cols-1 xxx-lg:grid-cols-2 xxx-2xl:grid-cols-3 items-start justify-items-center px-6 md:px-8 ${className}`}
    >
      <FooterContentPane title="Popular Topics" className="hidden">
        <div className="flex flex-wrap m-4 overflow-y-hidden max-h-20">
          <PopTopicText>Texas</PopTopicText>
          <PopTopicText>Texas State Parks</PopTopicText>
          <PopTopicText>Hill Country</PopTopicText>
          <PopTopicText>Austin</PopTopicText>
          <PopTopicText>Dallas</PopTopicText>
          <PopTopicText>Ohio</PopTopicText>
          <PopTopicText>National Park</PopTopicText>
        </div>
      </FooterContentPane>

      <FooterContentPane title="Search">
        <SearchBox className="pt-6" query={query} onChange={setQuery} />
      </FooterContentPane>
    </div>
  );
}
